import { RefreshCw } from "lucide-react";
import { useVersionCheck } from "@/hooks/useVersionCheck";
import { useLanguage } from "@/i18n/LanguageProvider";

// App-level "a newer build is live — reload" prompt. Shown only when an open tab
// is running a bundle older than the published /version.json (see useVersionCheck).
// User-initiated reload (not auto) so it never interrupts mid-action; a floating
// top pill so it doesn't shift layout or block the bottom controls.
export default function StaleVersionBanner() {
  const { stale } = useVersionCheck();
  const { t } = useLanguage();
  if (!stale) return null;
  return (
    <div
      className="fixed inset-x-0 top-0 z-[200] flex justify-center px-3 pointer-events-none"
      style={{ paddingTop: "max(10px, calc(env(safe-area-inset-top, 0px) + 6px))" }}
    >
      <div
        className="pointer-events-auto flex items-center gap-3 rounded-full pl-4 pr-1.5 py-1.5 shadow-[0_6px_24px_rgba(0,0,0,0.4)]"
        style={{
          background: "hsl(222 38% 10% / 0.96)",
          border: "1px solid hsl(187 72% 50% / 0.35)",
          backdropFilter: "blur(12px)",
          WebkitBackdropFilter: "blur(12px)",
        }}
      >
        <span className="text-[12px] font-display text-foreground/85 tracking-wide">
          {t("version.stale.message")}
        </span>
        <button
          type="button"
          onClick={() => window.location.reload()}
          className="flex items-center gap-1.5 rounded-full px-3 py-1.5 text-[12px] font-display font-semibold active:scale-[0.97] transition-transform"
          style={{ background: "hsl(187 72% 45%)", color: "white" }}
        >
          <RefreshCw size={13} />
          {t("version.stale.reload")}
        </button>
      </div>
    </div>
  );
}
